var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99999 10.6667C4.89542 10.6667 3.99999 11.5621 3.99999 12.6667C3.99999 13.0349 4.29847 13.3333 4.66666 13.3333H8.66666C9.03485 13.3333 9.33332 13.6318 9.33332 14C9.33332 14.3682 9.03485 14.6667 8.66666 14.6667H4.66666C3.56209 14.6667 2.66666 13.7712 2.66666 12.6667C2.66666 10.8257 4.15904 9.33334 5.99999 9.33334H10.6667C11.0348 9.33334 11.3333 9.63182 11.3333 10C11.3333 10.3682 11.0348 10.6667 10.6667 10.6667H5.99999Z",
    fill: "#16191E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99999 2.66668C6.89542 2.66668 5.99999 3.56211 5.99999 4.66668C5.99999 5.77125 6.89542 6.66668 7.99999 6.66668C9.10456 6.66668 9.99999 5.77125 9.99999 4.66668C9.99999 3.56211 9.10456 2.66668 7.99999 2.66668ZM4.66666 4.66668C4.66666 2.82573 6.15904 1.33334 7.99999 1.33334C9.84094 1.33334 11.3333 2.82573 11.3333 4.66668C11.3333 6.50763 9.84094 8.00001 7.99999 8.00001C6.15904 8.00001 4.66666 6.50763 4.66666 4.66668Z",
    fill: "#16191E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8619 10.8619C13.1223 10.6016 13.5444 10.6016 13.8047 10.8619L15.1381 12.1953C15.3984 12.4556 15.3984 12.8777 15.1381 13.1381L13.8047 14.4714C13.5444 14.7317 13.1223 14.7317 12.8619 14.4714C12.6016 14.211 12.6016 13.7889 12.8619 13.5286L13.0572 13.3333H10.6667C10.2985 13.3333 10 13.0348 10 12.6667C10 12.2985 10.2985 12 10.6667 12L13.0572 12L12.8619 11.8047C12.6016 11.5444 12.6016 11.1223 12.8619 10.8619Z",
    fill: "#16191E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivate);
export default __webpack_public_path__ + "static/media/activate.98abf77334ebcf78b51b51bd42092743.svg";
export { ForwardRef as ReactComponent };